import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import * as React from "react"
import { ethers } from "ethers"
import PropTypes from "prop-types"

const Header = ({ siteTitle }) => {
  const [wallet, setWallet] = React.useState("Connect Wallet")

  React.useEffect(() => {
    ; (async () => {
      if (window.ethereum) {
        window.ethereum.on(`accountsChanged`, accounts => {
          console.debug(accounts, `accountsChanged`)

          if (accounts.length) {
            const address = accounts[0]
            setWallet(`${address.slice(0, 6)}...${address.slice(-4)}`)
            return
          }
          setWallet(`Connect Wallet`)
        })
        window.ethereum.on(`chainChanged`, () => {
          window.location.reload()
        })
        const provider = new ethers.providers.Web3Provider(window.ethereum)
        const accounts = await provider.listAccounts()
        if (accounts.length) {
          const address = accounts[0]
          setWallet(`${address.slice(0, 6)}...${address.slice(-4)}`)
          return
        }
      }
    })()
  }, [])
  React.useEffect(() => {
    const { ethereum } = window
    if (ethereum) {
      const chainParams = [
        {
          chainId: "01",
          chainName: "Ethereum Mainnet",
          nativeCurrency: {
            name: "Ether",
            symbol: "ETH",
            decimals: 18,
          },
          rpcUrls: ["https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161"],
          blockExplorerUrls: ["https://etherscan.io"],
        },
      ]

      window.ethereum
        .request({ method: "wallet_addEthereumChain", chainParams })
        .catch(console.error)
    }
  })

  const connectHandler = async () => {
    if (window.ethereum) {
      const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
      await provider.send("eth_requestAccounts", []);
      const signer = provider.getSigner();
      const address = await signer.getAddress()
      setWallet(`${address.slice(0, 6)}...${address.slice(-4)}`)
    }
  }


  return (
    <header>
      <div class="h1_cont">
        
        <a href="https://wickedwitchworld.com/"><StaticImage
          src="../images/header-logo.png"
          quality={100}
          alt="Witch Hat header logo"
          class="header-logo"
        ></StaticImage></a>
        <h1 
          className = "header-title"
        >
          <Link
            to="https://wickedwitchworld.com/"
            style={{
              color: `white`,
              textDecoration: `none`,
            }}
          >
            {siteTitle}
          </Link>
        </h1>
      </div>

      <div class="account__container">
        <button
          class="header__btn"
          onClick={connectHandler}
        >
          {wallet}
        </button>
      </div>

    </header>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
